<div class="profile-header">
  <div class="top-bar hide-on-tablet-up">
    <app-back-button></app-back-button>
    <!-- <i class="material-icons" (click)="showShare = true">share</i>
    <app-share-bar *ngIf="showShare" (onClose)="showShare = false"></app-share-bar> -->
  </div>
  <div class="background flex-one has-pos-rel" [class.map]="latLng">
    <app-circle-initials *ngIf="isAgentProfile && shouldShowInitials"  [initials]="initials"></app-circle-initials>
    <div *ngIf="!latLng && !shouldShowInitials" #imageContainerRef class="photo is-flex has-flex-content-center full-height full-width">
      <div class="thumbnail">
        <img class="img"
        appImgIxImage appImgLoader
        [url]="imageUrl"
        [imageQualityPercentage]="100"
        src="{{ imageUrl }}" alt="" (error)="imgErrorHandler($event)">
      </div>
    </div>
    <div *ngIf="latLng" class="map is-flex has-flex-content-center">
      <app-map class="full-width" [latLng]="latLng" [isOffice]="true" [isLDP]="false"></app-map>
    </div>
    <ng-content select="[favourite]"></ng-content>
  </div>
  <section class="main-content is-flex-column has-flex-align-center has-flex-content-center">
    <p *ngIf="preNameText" class="pre-name-text">{{preNameText | translate}}</p>
    <span class="name-rating is-flex has-flex-align-center">
      <h1 id="profileHeader-text-name" class="name is-flex">{{ name }}</h1>
      <span class="review-rating is-flex has-flex-align-center" *ngIf="agentRating || agentReviews">
        <app-rating *ngIf="agentRating" [setRating]="agentRating" [showExact]="screenSize !== SCREEN_SIZE.MOBILE_ONLY"></app-rating>
        <button *ngIf="agentReviews" class="btn-link" (click)="reviewsClicked.emit()" translate="reviews.num-reviews" [translateParams]="{ num: agentReviews }"></button>
      </span>
    </span>
    <h5 id="profileHeader-text-description" class="description">{{ description }}</h5>
    <div class="content">
      <ng-content select="[main]"></ng-content>
    </div>
  </section>
</div>
